import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        state() {
            return {
                body: null,
                id: null,
                title: null,
                uuid: null,
                updated_at: null,
                created_at: null,
                activity_id: null,
                course_id: null,
                tags: null,
                media: [],
            };
        },

        getters: {
            note: state => state,
        },

        actions: {
            editField(context, payload) {
                // create logic to edit state
                context.commit('EDIT_FIELD', payload);
                context.commit(
                    'Notes/EDIT',
                    {
                        ...payload,
                        id: context.state.id,
                    },
                    { root: true }
                );
            },

            stageField(context, payload) {
                // create logic to edit state
                context.commit('EDIT_FIELD', payload);
            },
        },

        mutations: {
            EDIT_FIELD(state, payload) {
                state[payload.field] = payload.value;
            },
        },
    }
);
